<template>
    <b-modal
        id="sub-assignment-cooperation-modal"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        size="md"
        :title="$t('assignment.cooperate_sub_assignment')"
        @ok="onOk()">
        <div class="subassignment-cooperation">
            <b-form-checkbox
                class="subassignment-cooperation-toggle"
                v-model="checked"
                :aunchecked-value="false"
                :value="true"
                name="check-button"
                switch>
                {{ $t('assignment.collaborate') }}:
            </b-form-checkbox>

            <b-form-group
                class="subassignment-cooperation-options-group"
                v-if="checked"
                :label="$t('assignment.group_composition') + ':'">
                <b-form-radio
                    v-model="coopMakerType"
                    value="student"
                    >{{ $t('assignment.group_students_own_choice') }}
                </b-form-radio>
                <!--{{ 'assignment.edit.cooperation.maker.student }}-->
                <b-form-radio
                    v-model="coopMakerType"
                    value="random"
                    >{{ $t('assignment.collaborate_auto_assign') }}
                </b-form-radio>
                <!--{{ 'assignment.edit.cooperation.maker.random }}-->
                <b-form-radio
                    v-model="coopMakerType"
                    value="teacher"
                    >{{ $t('assignment.collaborate_teacher_assign') }}
                </b-form-radio>
                <!--{{ 'assignment.edit.cooperation.maker.teacher }}-->
            </b-form-group>

            <div
                class="subassignment-cooperation-amount"
                v-if="checked">
                <b-form-group
                    :label="$t('assignment.minimum_number_of_students_working_together')"
                    label-for="min">
                    <b-form-input
                        id="min"
                        v-model="minimum"
                        min="0"
                        type="number">
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    :label="
                        $t('assignment.maximum_number_of_students_working_together_zero_or_empty_if_there_is_no_limit')
                    "
                    label-for="max">
                    <b-form-input
                        id="max"
                        v-model="maximum"
                        min="0"
                        type="number">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-edit-sub-assignment-cooperation-modal-component',
    props: ['subAssignmentIn', 'groupIdIn'],
    data() {
        return {
            checked: !!this.subAssignmentIn.assignment_cooperations.length,
            minimum: this.subAssignmentIn.assignment_cooperations[0]?.minimum ?? 1,
            maximum: this.subAssignmentIn.assignment_cooperations[0]?.maximum ?? 2,
            coopMakerType: this.subAssignmentIn.assignment_cooperations[0]?.coop_maker_type ?? 'student',
        };
    },
    methods: {
        onOk() {
            if (this.checked && !this.subAssignmentIn.assignment_cooperations[0]) {
                this.store();
            } else if (this.checked && this.subAssignmentIn.assignment_cooperations[0]) {
                this.update(this.subAssignmentIn.assignment_cooperations[0]);
            } else if (!this.checked && this.subAssignmentIn.assignment_cooperations[0]) {
                this.remove(this.subAssignmentIn.assignment_cooperations[0]);
            }
        },
        afterSubmit(assignmentCooperation) {
            if (this.checked && this.coopMakerType !== 'student') {
                this.$emit('openTeacherCoop', assignmentCooperation);
            }
        },
        store() {
            this.alert.saving();

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                group_id: this.groupIdIn,
                minimum: this.minimum,
                maximum: this.maximum,
                coop_maker_type: this.coopMakerType,
            };

            this.axios.post(this.routes.subAssignmentCooperationStore(), data).then(
                (response) => {
                    this.subAssignmentIn.addRelation('assignment_cooperations', response.data);
                    this.alert.success();
                    this.afterSubmit(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        remove(assignmentCooperation) {
            this.alert
                .confirm(
                    this.$t('assignment.disable_collaboration_confirmation_title'),
                    this.$t('assignment.disable_collaboration_confirmation_body_sub_assignment'),
                    this.$t('assignment.disable'),
                    this.$t('assignment.disable'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.subAssignmentCooperationRemove(assignmentCooperation.id)).then(
                        (response) => {
                            assignmentCooperation.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        update(assignmentCooperation) {
            this.alert.saving();

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                assignment_cooperation_id: assignmentCooperation.id,
                group_id: this.groupIdIn,
                minimum: this.minimum,
                maximum: this.maximum,
                coop_maker_type: this.coopMakerType,
            };

            this.axios.post(this.routes.subAssignmentCooperationUpdate(), data).then(
                (response) => {
                    assignmentCooperation.update(response.data);
                    this.alert.success();
                    this.afterSubmit(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.custom-switch {
    ::v-deep .custom-control-label {
        &:before {
            top: -1px;
        }

        &:after {
            top: 1px;
        }
    }
}

.subassignment-cooperation,
.subassignment-cooperation-amount {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    column-gap: $grid-gutter-width;
}

.subassignment-cooperation-toggle,
.subassignment-cooperation-options-group {
    flex: 0 0 auto;
}

.subassignment-cooperation-options-group {
    ::v-deep .custom-control-label {
        &:before,
        &:after {
            top: 0.05rem;
        }
    }
}

.subassignment-cooperation {
    > div,
    .subassignment-cooperation-options-group {
        margin-bottom: $grid-gutter-width;
    }
}

.subassignment-cooperation-amount {
    flex: 1 0 100%;
    align-items: flex-start;

    .form-group {
        flex: 1 0 100%;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .subassignment-cooperation-amount {
        flex: 1 0 100%;
        align-items: flex-end;

        .form-group {
            flex: 0 0 calc(50% - 15px);
            margin-bottom: 0;
        }
    }
}
</style>
